import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mcommerce-audit-config',
  templateUrl: './mcommerce-audit-config.component.html',
  styleUrls: ['./mcommerce-audit-config.component.scss']
})
export class McommerceAuditConfigComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
